import { SupportAnnounce7Component } from "./current/SupportAnnounce7Component";

export function EntrepreneurAnnounce7FormComponent() {

    return (
        <SupportAnnounce7Component />
    );

}
